import { COUNTRY_CODE_ZH_TW } from './asset/country-code';
import { errorMessageEN } from './asset/error-message';
import { Marketplace_ZH_TW } from './asset/marketplace';
import { INDUSTRY_CODE_ZH_TW } from './asset/industry-code';
import { BalanceAsset_ZH_TW } from './asset/balance-asset';
import { FINANCIAL_METRICS_ZH_TW } from './asset/financial-metrics';
import { FUNDER_BREAD_CRUMB_ZH_TW } from './asset/funder-bread-crumb';
import { FUNDER_PROFILE_ZH_TW } from './asset/funder-profile';
import { COMMON_ZH_TW } from './asset/common';
import { LOGIN_ZH_TW } from './asset/login';
import { errorMessage_ZH_TW } from './asset/error-message';

export default {
    ...errorMessage_ZH_TW,
    ...FUNDER_BREAD_CRUMB_ZH_TW,
    ...COUNTRY_CODE_ZH_TW,
    ...errorMessageEN,
    ...Marketplace_ZH_TW,
    ...INDUSTRY_CODE_ZH_TW,
    ...BalanceAsset_ZH_TW,
    ...FINANCIAL_METRICS_ZH_TW,
    ...FUNDER_PROFILE_ZH_TW,
    ...COMMON_ZH_TW,
    ...LOGIN_ZH_TW,
}